import * as Constants from '../../Pages/Constants';
import React, { useState, Component } from 'react';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { enUS, esES, frFR } from '@mui/x-data-grid/locales';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import { Icon } from 'semantic-ui-react';
import Profile from './PatientBox.js';
import { Card, Row } from "antd";
import '../components-style.css';
import {FormattedMessage} from 'react-intl';
import Utils from "../Common/Utils.js";
import stand_alert from '../../Images/Position/stand-alert.png';
import SPO2_grey from '../../Images/SPO2/spo2_grey.png';
import bloodPressure_grey from '../../Images/BloodPressure/BloodPressure_grey.png';
import weight_grey from '../../Images/Weight/Weight_grey.png';
import { AiTwotoneSetting } from 'react-icons/ai'
import { GiBackPain } from "react-icons/gi";
import { LiaSmileWinkSolid } from "react-icons/lia";
import { TbFileSmile } from "react-icons/tb";

import IconButton from '@mui/material/IconButton';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import GraphPopup from "../Common/GraphPopup.js";
import AlertManager from '../Alerts/alertManagerFrontend.js';
import PatientFunctionsGetter from '../../Controller/getSQLPatientFunctions.js';
import GetDataController from '../../Controller/getPatientGenericData.js'
import TuckyDataManager from '../Tucky/TuckyDataManager.js';
import PulseOximeterManager from '../PulseOximeter/pulseOximeterManager.js'
import CopyableId from '../Common/CopyableId.js';
import { userIsSuperAdmin, userIsPractitioner, userRpps } from '../../Controller/userRoles.js';
import TensionManager from '../Tensiometer/TensiometerManager.js'
import ScaleManager from '../Scale/ScaleManager.js';
import PainManager from '../Pain/PainManager.js';
import HealthFormManager from '../Healthform/HealthformManager.js';
import BreathingManager from '../Niv/BreathingManager.js';
import PhotographyDataManager from '../Photo/PhotographyDataManager.js';
import img_vni from '../../Images/Devices/RESPIRATION.png';
import img_leakage from '../../Images/Devices/LEAKAGE.png';
import img_oxygentherapy from '../../Images/Devices/OXYGEN_MASK.png';
import healthscale_grey from '../../Images/Healthform/health_grey.png';
import ruler_grey from '../../Images/Healthform/ruler_grey.png';
import PatientProfileModal from './PatientProfileModal.js';
import PatientCardList from './PatientCardList.js';
import { canValidateAllTls, shouldShowTls } from './alertPermissions.js';

// DataGrid ships its own translations ("Rows per page:", "n rows selected", the
// filter/column panels). Without this the grid stays in English whatever the
// account language, so pick the pack matching the react-intl locale.
const DATA_GRID_LOCALES = { fr: frFR, es: esES, en: enUS };
const dataGridLocaleText = (locale) => {
    const pack = DATA_GRID_LOCALES[String(locale || 'en').slice(0, 2)] || enUS;
    return pack.components.MuiDataGrid.defaultProps.localeText;
};

class PatientSimpleList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            inside_props : [],
            check_patient_data: {},
            checked_patients: {},
            cleared_alerts_patients: {},
            all_checked: false,
            paginationModel: { page: 0, pageSize: 20 },
            confirmDialogOpen: false,
            confirmDialogType: null,
            confirmDialogPatientId: null,
            confirmDialogPatientDataList: null,
            temperatureSize : "huge",
            positionSize : "55px",
            heartrateOximeterSize : "huge",
            heartrateTensiometerSize : "huge",
            usageNivSize : "huge",
            usageOxigentherapySize : "huge",
            painSize : 50,
            healthformAlimentationSize : "huge",
            healthformEQ5DSize : 50,
            healthformEQ5DScaleSize : 50,
            healthformSF36Size : 50,
            healthformMDASISize : 50,
            selectedPatientProfile: null,
            hideAlertCols: false,
            hideMedicalCols: false,
            showAllColsTablet: false,
        }

        this.handleGraphPopup = this.handleGraphPopup.bind(this);
        this.handleInsideProps = this.handleInsideProps.bind(this);
        this.handleTemperatureSize = this.handleTemperatureSize.bind(this);
        this.handlePositionSize = this.handlePositionSize.bind(this);
        this.handleHeartrateOximeterSize = this.handleHeartrateOximeterSize.bind(this);
        this.handleHeartrateTensiometerSize = this.handleHeartrateTensiometerSize.bind(this);
        this.handleUsageNivSize = this.handleUsageNivSize.bind(this);
        this.handleUsageOxigentherapySize = this.handleUsageOxigentherapySize.bind(this);
        this.handlePainSize = this.handlePainSize.bind(this);
        this.handleHealthformEQ5DSize = this.handleHealthformEQ5DSize.bind(this);
        this.handleHealthformEQ5DScaleSize = this.handleHealthformEQ5DScaleSize.bind(this);
        this.handleHealthformSF36Size = this.handleHealthformSF36Size.bind(this);
        this.handleHealthformMDASISize = this.handleHealthformMDASISize.bind(this);
        this.handleHealthformAlimentationSize = this.handleHealthformAlimentationSize.bind(this);
    };

    handleTemperatureSize(status) {
        this.setState(state => ({
            temperatureSize: status
        }));
    }

    handlePositionSize(status) {
        this.setState(state => ({
            positionSize: status
        }));
    }

    handleHeartrateOximeterSize(status) {
        this.setState(state => ({
            heartrateOximeterSize: status
        }));
    }

    handleHeartrateTensiometerSize(status) {
        this.setState(state => ({
            heartrateTensiometerSize: status
        }));
    }

    handleUsageNivSize(status) {
        this.setState(state => ({
            usageNivSize: status
        }));
    }

    handleUsageOxigentherapySize(status) {
        this.setState(state => ({
            usageOxigentherapySize: status
        }));
    }

    handlePainSize(status) {
        this.setState(state => ({
            painSize: status
        }));
    }

    handleHealthformEQ5DSize(status) {
        this.setState(state => ({
            healthformEQ5DSize: status
        }));
    }

    handleHealthformEQ5DScaleSize(status) {
        this.setState(state => ({
            handleHealthformEQ5DScaleSize: status
        }));
    }

    handleHealthformSF36Size(status) {
        this.setState(state => ({
            healthformSF36Size: status
        }));
    }

    handleHealthformMDASISize(status) {
        this.setState(state => ({
            healthformMDASISize: status
        }));
    }

    handleHealthformAlimentationSize(status) {
        this.setState(state => ({
            healthformAlimentationSize: status
        }));
    }

    handleInsideProps(status) {
        let new_list = this.state.inside_props
        new_list.push(status)
        this.setState(state => ({
            inside_props: new_list
        }));
    }

    async componentDidMount(){

        this.audio = AlertManager.getAudioInstance();
        this.refreshData(true);

        //Function to refresh each profile at regular time
        this.intervalID = setInterval(async () => {
            this.refreshData(false);

        }, 40000) /* Reactualize every 40 000 ms */
    }

    //Function to handle data loading and refresh
    async refreshData(fullLoad){

        //Date variables
        const twelveHoursInMs = 43200000;
        let current_Date = new Date();

        let requestDateStart;
        let requestDateEnd;        

        if (fullLoad) {
            // First load: complete data load with cases "did mount" & "change date" (including today or not)
            requestDateStart = new Date (this.props.dateSelected[0]);
            requestDateEnd  = new Date (this.props.dateSelected[1]);
        }
        else{
            // Refresh loads: load only last 12 hours
            requestDateStart = new Date(current_Date.getTime() - twelveHoursInMs);
            requestDateEnd = new Date(current_Date.getFullYear(), current_Date.getMonth(), current_Date.getDate(), 23, 59, 59, 999);
        }

        let selectedDateStart = new Date(this.props.dateSelected[0]);
        let selectedDateEnd = new Date(this.props.dateSelected[1]);

        let x = 0;

        while (this.props.profilesInformation[x]) {
            // Skip mal-created patients
            if (this.props.profilesInformation[x].Patient_Data._invalid) {
                x++;
                continue;
            }
            //Periodic log
            if (process.env.NODE_ENV === 'development'){
                console.log("refreshData " + fullLoad + " of " + this.props.profilesInformation[x].Patient_Data.firstname);
                console.log(this.props.profilesInformation[x]);
            }


            // Get all data
            let all_data_request = [];
            if (fullLoad || this.props.profilesInformation[x].Patient_Data.monitoring_activation !== "no") {
                all_data_request = await GetDataController.get_patient_generic_Data(this.props.profilesInformation[x].Patient_Data.id_patient, requestDateStart, requestDateEnd, Utils.getFHIRCodesFromFeatures(this.props.subscription_info.features));
            }

            /////////////////////// VARIABLES ///////////////////////
            let local_alert_state = this.state.frontend_alert_state

            // ******************************************************************//
            // *************************** TUCKY or AOJ20 ***********************//
            // ******************************************************************//  
            let connection_State
            let lastPositionData = []
            let lastBatteryData = []

            if ((this.props.profilesInformation[x].Patient_Data.devices.device1.id !== 'dissociate')||(this.props.profilesInformation[x].Patient_Data.monitoring_activation === 'smartphone')||(this.props.profilesInformation[x].Patient_Data.monitoring_activation === 'no_device')||(fullLoad)) {

                // 1- GET DATA
                
                // Get temperature
                let temperature_data_request = Utils.filterData(all_data_request, "8310-5")

                // Get battery and position depending on connection state
                let battery_data_request = []
                let position_data_request = []
                connection_State = TuckyDataManager.getConnectionState(temperature_data_request);             
                if(connection_State === "connected"){
                    // Battery
                    battery_data_request = Utils.filterData(all_data_request, "8418512.6")
                    // Position
                    position_data_request = Utils.filterData(all_data_request, "72282-7")
                }
                
                // 2- FORMAT & MERGE DATA WHEN FULLLOAD OR SAME DAY
                if ( (fullLoad) || (Utils.isSameDay(current_Date, selectedDateEnd)) ) {
                    this.props.profilesInformation[x].Patient_Data.thermometer    = TuckyDataManager.formatAndMergeTemperatureData(fullLoad, this.props.profilesInformation[x].Patient_Data.thermometer, temperature_data_request);
                    this.props.profilesInformation[x].Patient_Data.battery        = TuckyDataManager.formatAndMergeBatorPosData(fullLoad, this.props.profilesInformation[x].Patient_Data.battery, battery_data_request);
                    this.props.profilesInformation[x].Patient_Data.position       = TuckyDataManager.formatAndMergeBatorPosData(fullLoad, this.props.profilesInformation[x].Patient_Data.position, position_data_request);
                }
                battery_data_request = null;
                position_data_request = null; 

                // update alert curve with time (must be here to allow real time date change)
                this.props.profilesInformation[x].Patient_Data.MaxFeverDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profilesInformation[x].Patient_Data.alerts.fever_alert.threshold);
            }

            // ***************************************************************************************************************************************************************************//


            // ******************************************************************//
            // *************************** PULSE OX  ****************************//
            // ******************************************************************//  
            if ((this.props.profilesInformation[x].Patient_Data.devices.device2.id !== 'dissociate')||Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("niv"))||Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("oxigen_therapy"))||(fullLoad)){

                // 1- GET DATA
                let PrSp02_data_request = Utils.filterData(all_data_request, "2708-6")

                // 2- FORMAT & MERGE DATA WHEN FULLLOAD OR SAME DAY
                if ( (fullLoad) || (Utils.isSameDay(current_Date, selectedDateEnd)) ) {
                    this.props.profilesInformation[x].Patient_Data.pulseOximeter    = PulseOximeterManager.formatAndMergeOximeterData(fullLoad, this.props.profilesInformation[x].Patient_Data.pulseOximeter, PrSp02_data_request);
                }
                PrSp02_data_request = null; 

                // Time related data ti be updated at each cycle (must be here to allow real time date change)
                this.props.profilesInformation[x].Patient_Data.MaxPulseRateDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profilesInformation[x].Patient_Data.alerts.PR_alert.threshold);
                this.props.profilesInformation[x].Patient_Data.MinSpO2Drawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profilesInformation[x].Patient_Data.alerts.SPO2_alert.threshold);
            }
            // ***************************************************************************************************************************************************************************//


            // ******************************************************************//
            // *************************** TENSIOMETER***************************//
            // ******************************************************************//  
            if ((this.props.profilesInformation[x].Patient_Data.devices.device3.id !== 'dissociate')||(fullLoad)){

                // 1- GET DATA
                let bloodpressure_data_request = Utils.filterData(all_data_request, "8460-6")

                // 2- FORMAT & MERGE DATA WHEN FULLLOAD OR SAME DAY
                if ( (fullLoad) || (Utils.isSameDay(current_Date, selectedDateEnd)) ) {
                    this.props.profilesInformation[x].Patient_Data.pulseTensiometer    = TensionManager.formatAndMergeTensiometerData(fullLoad, this.props.profilesInformation[x].Patient_Data.pulseTensiometer, bloodpressure_data_request);                    // Update tensiometer graph
                }
                bloodpressure_data_request = null;

                // update alert curve with time (must be here to allow real time date change)        
                this.props.profilesInformation[x].Patient_Data.MaxPulseRateDrawingTension =  Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profilesInformation[x].Patient_Data.alerts.bloodpressure_PR_alert.threshold);
                this.props.profilesInformation[x].Patient_Data.MaxSystolicDrawingTension =   Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profilesInformation[x].Patient_Data.alerts.bloodpressure_sys_high_alert.threshold);
                this.props.profilesInformation[x].Patient_Data.MaxDiastolicDrawingTension =  Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profilesInformation[x].Patient_Data.alerts.bloodpressure_dia_alert.threshold);
            }
            // ***************************************************************************************************************************************************************************//
            


            // *******************************************************************//
            // ***************************** SCALE *******************************//
            // *******************************************************************//
            if ((this.props.profilesInformation[x].Patient_Data.devices.device4.id !== 'dissociate')||(fullLoad)){
                    
                // 1- GET DATA
                let scale_data_request = Utils.filterData(all_data_request, "29463-7")
                scale_data_request = Utils.filterScaleData(scale_data_request)

                // 2- FORMAT & MERGE DATA WHEN FULLLOAD OR SAME DAY
                if ( (fullLoad) || (Utils.isSameDay(current_Date, selectedDateEnd)) ) {
                    this.props.profilesInformation[x].Patient_Data.scale_data    = ScaleManager.formatAndMergeScaleData(fullLoad, this.props.profilesInformation[x].Patient_Data.scale_data, scale_data_request);
                }
                scale_data_request = null;

                // update alert curve with time (must be here to allow real time date change)
                this.props.profilesInformation[x].Patient_Data.weightThreshold = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profilesInformation[x].Patient_Data.alerts.weight_alert.threshold);
            }
        
            // ***************************************************************************************************************************************************************************//



            // ******************************************************************//
            // ***************************   PAIN    ****************************//
            // ******************************************************************//
            if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("pain"))) {

                // 1- GET DATA
                let pain_data_request = Utils.filterData(all_data_request, "72514-3")

                // 2- FORMAT & MERGE DATA WHEN FULLLOAD OR SAME DAY
                if ( (fullLoad) || (Utils.isSameDay(current_Date, selectedDateEnd)) ) {
                    this.props.profilesInformation[x].Patient_Data.pain    = PainManager.formatAndMergePainData(this.props.profilesInformation[x].Patient_Data.pain, pain_data_request);
                }
                pain_data_request = null;

                // update alert curve with time (must be here to allow real time date change)
                this.props.profilesInformation[x].Patient_Data.MaxPainDrawing =              Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profilesInformation[x].Patient_Data.alerts.pain_alert.threshold);
            }
            // ***************************************************************************************************************************************************************************//



            // *******************************************************************//
            // ****************************** EQ5D *******************************//
            // *******************************************************************//
            if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_EQ5D"))) {

                // 1- GET DATA
                let healthform_data_request = Utils.filterData(all_data_request, "45698-1")
                healthform_data_request = Utils.filterHealthform(healthform_data_request, "EQ5D5L")
                           
                // 2- FORMAT & MERGE DATA WHEN FULLLOAD OR SAME DAY
                if ( (fullLoad) || (Utils.isSameDay(current_Date, selectedDateEnd)) ) {
                    this.props.profilesInformation[x].Patient_Data.eq5d = HealthFormManager.formatAndMergeEQ5DData(this.props.profilesInformation[x].Patient_Data.eq5d, healthform_data_request);
                }
                healthform_data_request = null;

                // update alert curve with time (must be here to allow real time date change)
                this.props.profilesInformation[x].Patient_Data.MaxHealthformDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profilesInformation[x].Patient_Data.alerts.eq5d_alert.threshold);
                this.props.profilesInformation[x].Patient_Data.MaxHealthscaleDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profilesInformation[x].Patient_Data.alerts.eq5d_scale_alert.threshold);
            }
            // ***************************************************************************************************************************************************************************//



            // *******************************************************************//
            // ****************************** SF36 *******************************//
            // *******************************************************************//
            if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_SF36"))) {

                // 1- GET DATA
                let healthform_data_request = Utils.filterData(all_data_request, "45698-1")
                healthform_data_request = Utils.filterHealthform(healthform_data_request, "SF36")

                // 2- FORMAT & MERGE DATA WHEN FULLLOAD OR SAME DAY
                if ( (fullLoad) || (Utils.isSameDay(current_Date, selectedDateEnd)) ) {
                    this.props.profilesInformation[x].Patient_Data.sf36 = HealthFormManager.formatAndMergeSF36Data(this.props.profilesInformation[x].Patient_Data.sf36, healthform_data_request);
                }
                healthform_data_request = null;

                // update alert curve with time (must be here to allow real time date change)
                this.props.profilesInformation[x].Patient_Data.MaxHealthformDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profilesInformation[x].Patient_Data.alerts.sf36_alert.threshold);
            }
            // ***************************************************************************************************************************************************************************//



            // *******************************************************************//
            // ****************************** MDASI ******************************//
            // *******************************************************************//
            if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_MDASI"))) {

                // 1- GET DATA
                let healthform_data_request = Utils.filterData(all_data_request, "45698-1")
                healthform_data_request = Utils.filterHealthform(healthform_data_request, "MDASI")

                // 2- FORMAT & MERGE DATA WHEN FULLLOAD OR SAME DAY
                if ( (fullLoad) || (Utils.isSameDay(current_Date, selectedDateEnd)) ) {
                    this.props.profilesInformation[x].Patient_Data.mdasi = HealthFormManager.formatAndMergeMDASIData(this.props.profilesInformation[x].Patient_Data.mdasi, healthform_data_request);
                }
                healthform_data_request = null;
            }
            // ***************************************************************************************************************************************************************************//



            // *******************************************************************//
            // ****************** HEALTHFORM ALIMENTATION ************************//
            // *******************************************************************//
            if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_ALIMENTATION"))) {

                // 1- GET DATA
                let healthform_data_request = Utils.filterData(all_data_request, "45698-1")
                healthform_data_request = Utils.filterHealthform(healthform_data_request, "ALIMENTATION")

                // 2- FORMAT & MERGE DATA WHEN FULLLOAD OR SAME DAY
                if ( (fullLoad) || (Utils.isSameDay(current_Date, selectedDateEnd)) ) {
                    this.props.profilesInformation[x].Patient_Data.alimentation = HealthFormManager.formatAndMergeAlimentationData(this.props.profilesInformation[x].Patient_Data.alimentation, healthform_data_request);
                }
                healthform_data_request = null;
            }



            // *******************************************************************//
            // ************************* RESPIRATION *****************************//
            // *******************************************************************//
            if ((Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("niv")))
             || (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("oxigen_therapy")))) { 

                // 1- GET DATA
                let nvi_schedule_data_request = Utils.filterData(all_data_request, "69988-4");
                let oxi_schedule_data_request = Utils.filterData(all_data_request, "LP75328-2");
                let respiratory_rate_data_request = Utils.filterData(all_data_request, "9279-1");
                let respiratory_leak_data_request = Utils.filterData(all_data_request, "33456-5");
                let oxygen_flow_rate_data_request = Utils.filterData(all_data_request, "3151-8");

                // 2- FORMAT & MERGE DATA WHEN FULLLOAD OR SAME DAY
                if ( (fullLoad) || (Utils.isSameDay(current_Date, selectedDateEnd)) ) {
                    //TMP: should be same function called 3 times (for each data type) => formatAndMergeBreathingCurve
                    //TMP: should also have function called for schedules => formatAndMergeBreathingSchedule
                    this.props.profilesInformation[x].Patient_Data.breathing = BreathingManager.formatAndMergeBreathingData(this.props.profilesInformation[x].Patient_Data.breathing, nvi_schedule_data_request, oxi_schedule_data_request, respiratory_rate_data_request, respiratory_leak_data_request, oxygen_flow_rate_data_request, selectedDateEnd, 0);
                }
                nvi_schedule_data_request = null;
                oxi_schedule_data_request = null;

                // update alert curve with time (must be here to allow real time date change)
                this.props.profilesInformation[x].Patient_Data.MaxBreathingRateDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profilesInformation[x].Patient_Data.alerts.breathing_rate_alert.threshold);
                this.props.profilesInformation[x].Patient_Data.MaxBreathingOxygenRateDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profilesInformation[x].Patient_Data.alerts.breathing_oxygen_rate_alert.threshold);
                this.props.profilesInformation[x].Patient_Data.MaxBreathingLeakageDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profilesInformation[x].Patient_Data.alerts.breathing_leakage_alert.threshold);
                this.props.profilesInformation[x].Patient_Data.MaxBreathingObservanceDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profilesInformation[x].Patient_Data.alerts.breathing_observance_alert.threshold);
            }
            // ***************************************************************************************************************************************************************************//



            // ******************** CURRENT TIME GRAPH UPDATE ************************//
            this.props.profilesInformation[x].Patient_Data.currentTime = Utils.setCurrentTimePoint(selectedDateEnd);
            this.setState({
                frontend_alert_state : local_alert_state
            })
            local_alert_state = null;

            x++;
        }
    }

    handleGraphPopup(status) {
        let props_list = this.state.inside_props
        props_list.splice(status, 1)
        this.setState(state => ({
            inside_props: props_list
        }));
    }

    requestCheckPatient = (id_patient) => {
        this.setState({ confirmDialogOpen: true, confirmDialogType: 'single', confirmDialogPatientId: id_patient });
    };

    // pageRows: the rows of the currently displayed page only (grid or card view)
    requestCheckAllPatients = (pageRows) => {
        if (!canValidateAllTls(
            this.props.accountInformation,
            this.props.subscription_info?.features,
            pageRows
        )) return;
        this.setState({ confirmDialogOpen: true, confirmDialogType: 'all', confirmDialogPatientDataList: pageRows });
    };

    handleConfirmDialogClose = () => {
        this.setState({ confirmDialogOpen: false, confirmDialogType: null, confirmDialogPatientId: null, confirmDialogPatientDataList: null });
    };

    handleConfirmDialogAccept = async () => {
        const { confirmDialogType, confirmDialogPatientId, confirmDialogPatientDataList } = this.state;
        this.setState({ confirmDialogOpen: false, confirmDialogType: null, confirmDialogPatientId: null, confirmDialogPatientDataList: null });
        if (confirmDialogType === 'single' && confirmDialogPatientId) {
            await this.handleCheckPatient(confirmDialogPatientId);
        } else if (confirmDialogType === 'all' && confirmDialogPatientDataList) {
            await this.handleCheckAllPatients(confirmDialogPatientDataList);
        }
    };

    handleCheckPatient = async (id_patient) => {
        const newDate = new Date().toISOString();
        const id_user = this.props.accountInformation?.id_user || null;
        const user_name = this.props.accountInformation ? (this.props.accountInformation.firstName + " " + this.props.accountInformation.lastName) : null;
        const structure_name = this.props.struct_info?.struct_name || null;
        const newEntry = { date: newDate, id_user: id_user, user_name: user_name, structure_name: structure_name };
        const current = this.state.check_patient_data[id_patient] !== undefined
            ? this.state.check_patient_data[id_patient]
            : (this.props.profilesInformation.find(p => p.Patient_Data.id_patient === id_patient)?.Patient_Data.check_patient || []);
        const updated = [newEntry, ...(current || [])];
        this.setState(state => ({
            check_patient_data: { ...state.check_patient_data, [id_patient]: updated },
            checked_patients: { ...state.checked_patients, [id_patient]: true }
        }));
        await PatientFunctionsGetter.update_patient_check(id_patient, id_user, user_name, structure_name);
    };

    handleCheckAllPatients = async (pageRows) => {
        if (!canValidateAllTls(
            this.props.accountInformation,
            this.props.subscription_info?.features,
            pageRows
        )) return;
        const pagePatients = pageRows
            .filter(patient => patient.lpp_code && patient.monitoringActive);
        for (const patient of pagePatients) {
            await this.handleCheckPatient(patient.id_patient);
        }
        this.setState({ all_checked: true });
    };

    // Returns true if the current user (as a practitioner) is authorized to validate TLS for the given row.
    // Rule: if the patient has a medical delegate practitioner, only that practitioner can validate.
    //       Otherwise, only the concerned_speciality practitioner can validate.
    isTlsAuthorizedForPatient = (row) => {
        const acc = this.props.accountInformation;
        if (!userIsPractitioner(acc)) return false;
        const currentRpps = userRpps(acc);
        if (!currentRpps) return false;
        const delegateRpps = row.delegate_medical_alert;
        const hasMedicalDelegate = delegateRpps && delegateRpps !== 'no' && delegateRpps !== 'na';
        if (hasMedicalDelegate) return currentRpps === String(delegateRpps);
        const specialityRpps = row.rpps_id_practioner_speciality;
        return specialityRpps ? currentRpps === String(specialityRpps) : false;
    };

    openMetricGraph = (field, id_patient) => {
        let accountInformation = {
            role: this.props.userRole
        }
        this.handleInsideProps({type: field, dateSelected: this.props.dateSelected, intl: this.props.intl, profileData: this.props.get_profile_data(id_patient, this.props.profilesInformation, this.props.dateSelected), accountInformation: accountInformation})
    };

    openPatientProfile = (id_patient) => {
        let profileMatch = this.props.profilesInformation.find(e => e.Patient_Data.id_patient === id_patient);
        if (profileMatch) {
            this.setState({ selectedPatientProfile: profileMatch.Patient_Data });
        }
    };

    handleCellClick = (params) => {
        switch (params.field) {
            case "EQ5D":
            case "EQ5DHealthscale":
            case "SF36":
            case "MDASI":
            case "Alimentation":
            case "tuckyTemperature":
            case "oximeterPulseRate":
            case "oximeterSPO2":
            case "tensiometerPulseRate":
            case "tensiometerBloodpressure":
            case "scaleWeight":
            case "pain":
            case "NIVUsage":
            case "NIVLeak":
            case "NIVRate":
            case "OxiRate":
            case "OxiUsage":
                this.openMetricGraph(params.field, params.row.id_patient)
                break
            case "patientName":
                this.openPatientProfile(params.row.id_patient)
                break
            default:
                break
        }
    };

    convert_patient_data_name_to_grid_data_name = (patient_data) => {
        let ret
        let values = [
            {patient: "thermometer", grid: "tuckyTemperature"},
            {patient: "weight", grid: "scaleWeight"},
            {patient: "position", grid: "tuckyPosition"},
            {patient: "pain", grid: "pain"},
            {patient: "eq5d", grid: "EQ5D"},
            {patient: "sf36", grid: "SF36"},
            {patient: "mdasi", grid: "MDASI"},
            {patient: "alimentation", grid: "Alimentation"},
        ]
        ret = values.find(v => v.patient === patient_data)
        if (ret !== undefined) {
            ret = ret.grid
        }
        return ret
    };

    render(){
        let PatientDataList = []
        let keyConverter = this.convert_patient_data_name_to_grid_data_name
        this.props.profilesInformation.forEach((profile, index) => {
            if (profile.Patient_Data._invalid) return;
            const patientCheckData = this.state.check_patient_data[profile.Patient_Data.id_patient] !== undefined
                ? this.state.check_patient_data[profile.Patient_Data.id_patient]
                : profile.Patient_Data.check_patient;
            const lastEntry = (patientCheckData && patientCheckData.length > 0) ? patientCheckData[0] : null;
            const lastVisitDate = lastEntry ? (lastEntry.date || lastEntry) : null;
            const lastVisitUserName = lastEntry ? lastEntry.user_name : null;
            const lastVisitStructureName = lastEntry ? lastEntry.structure_name : null;
            let hasNewAlert = false;
            if (lastVisitDate && profile.Patient_Data.alerts_triggered) {
                hasNewAlert = profile.Patient_Data.alerts_triggered.some(a => a.sent && new Date(a.sent) > new Date(lastVisitDate));
            }
            let new_profile = {
                id: index + 1,
                id_patient: profile.Patient_Data.id_patient,
                patientName: profile.Patient_Data.firstname + " " + profile.Patient_Data.lastname,
                monitoringActive: profile.Patient_Data.monitoring_activation && profile.Patient_Data.monitoring_activation !== 'no',
                patientBirthdate: profile.Patient_Data.birthdate,
                userName: profile.Patient_Data.FK_User_mail,
                check_patient_last: lastVisitDate,
                check_patient_deadline: lastVisitDate ? new Date(new Date(lastVisitDate).getTime() + 15 * 24 * 60 * 60 * 1000).toISOString() : null,
                check_patient_user_name: lastVisitUserName,
                check_patient_structure_name: lastVisitStructureName,
                is_checked: !!this.state.checked_patients[profile.Patient_Data.id_patient],
                lpp_code: profile.Patient_Data.lpp_code || null,
                delegate_medical_alert: profile.Patient_Data.delegate_medical_alert || null,
                rpps_id_practioner_speciality: profile.Patient_Data.rpps_id_practioner_speciality || null,
            }
            if (this.props.accountInformation.anonymised_patient) {
                new_profile.patientName = new_profile.id_patient
            }
            Object.keys(profile.Patient_Data).forEach(function(key){
                let gridKey
                switch (key) {
                    //Cases with simple data
                    //Tucky temperature
                    case "thermometer":
                    //Position
                    case "position":
                    //Pain
                    case "pain":
                        gridKey = keyConverter(key)
                        if (profile.Patient_Data[key] === undefined || profile.Patient_Data[key].length === 0) {
                            new_profile[gridKey] = '-'
                        }
                        else {
                            new_profile[gridKey] = profile.Patient_Data[key][profile.Patient_Data[key].length - 1].y;                
                        }
                        break

                    //Cases multiple data
                    //Oximeter
                    case "pulseOximeter":
                        if (profile.Patient_Data.pulseOximeter === undefined || profile.Patient_Data.pulseOximeter.pulseRate === undefined || profile.Patient_Data.pulseOximeter.pulseRate.length === 0) {
                            new_profile.oximeterPulseRate = '-'
                        }
                        else {
                            new_profile.oximeterPulseRate = profile.Patient_Data.pulseOximeter.pulseRate[profile.Patient_Data.pulseOximeter.pulseRate.length - 1].y;
                        }
                        if (profile.Patient_Data.pulseOximeter === undefined || profile.Patient_Data.pulseOximeter.sp02 === undefined || profile.Patient_Data.pulseOximeter.sp02.length === 0) {
                            new_profile.oximeterSPO2 = '-'
                        }
                        else {
                            new_profile.oximeterSPO2 = profile.Patient_Data.pulseOximeter.sp02[profile.Patient_Data.pulseOximeter.sp02.length - 1].y;
                        }
                        break
                    //Tensiometer
                    case "pulseTensiometer":
                        if (profile.Patient_Data.pulseTensiometer === undefined || profile.Patient_Data.pulseTensiometer.pulseRate === undefined || profile.Patient_Data.pulseTensiometer.pulseRate.length === 0) {
                            new_profile.tensiometerPulseRate = '-'
                        }
                        else {
                            new_profile.tensiometerPulseRate = profile.Patient_Data.pulseTensiometer.pulseRate[profile.Patient_Data.pulseTensiometer.pulseRate.length - 1].y;
                        }
                        if (profile.Patient_Data.pulseTensiometer === undefined || profile.Patient_Data.pulseTensiometer.systolic === undefined || profile.Patient_Data.pulseTensiometer.systolic.length === 0 || profile.Patient_Data.pulseTensiometer.diastolic === undefined || profile.Patient_Data.pulseTensiometer.diastolic.length === 0) {
                            new_profile.tensiometerBloodpressure = '-'
                        }
                        else {
                            new_profile.tensiometerBloodpressure = profile.Patient_Data.pulseTensiometer.systolic[profile.Patient_Data.pulseTensiometer.systolic.length - 1].y + '/' + profile.Patient_Data.pulseTensiometer.diastolic[profile.Patient_Data.pulseTensiometer.diastolic.length - 1].y;
                        }
                        break
                    //Scale
                    case "scale_data":
                        if (profile.Patient_Data.scale_data === undefined || profile.Patient_Data.scale_data.weight === undefined || profile.Patient_Data.scale_data.weight.length === 0) {
                            new_profile.scaleWeight = '-'
                        }
                        else {
                            new_profile.scaleWeight = profile.Patient_Data.scale_data.weight[profile.Patient_Data.scale_data.weight.length - 1].y;
                        }
                        break
                    //NIV && Oxigentherapy
                    case "breathing":
                        //NIV
                        if (profile.Patient_Data.breathing === undefined || profile.Patient_Data.breathing.respiratory_rate === undefined || profile.Patient_Data.breathing.respiratory_rate.length === 0) {
                            new_profile.NIVRate = '-'
                        }
                        else {
                            new_profile.NIVRate = profile.Patient_Data.breathing.respiratory_rate[profile.Patient_Data.breathing.respiratory_rate.length - 1].y;
                        }
                        if (profile.Patient_Data.breathing === undefined || profile.Patient_Data.breathing.respiratory_leak == undefined || profile.Patient_Data.breathing.respiratory_leak.length === 0) {
                            new_profile.NIVLeak = '-'
                        }
                        else {
                            new_profile.NIVLeak = profile.Patient_Data.breathing.respiratory_leak[profile.Patient_Data.breathing.respiratory_leak.length - 1].y;
                        }
                        if (profile.Patient_Data.breathing === undefined || profile.Patient_Data.breathing.niv_usage === undefined || profile.Patient_Data.breathing.niv_usage.length === 0) {
                            new_profile.NIVUsage = '-'
                        }
                        else {
                            new_profile.NIVUsage = profile.Patient_Data.breathing.niv_usage[profile.Patient_Data.breathing.niv_usage.length - 1].y;
                        }

                        //Oxigentherapy
                        if (profile.Patient_Data.breathing === undefined || profile.Patient_Data.breathing.oxygen_flow_rate === undefined || profile.Patient_Data.breathing.oxygen_flow_rate.length === 0) {
                            new_profile.OxiRate = '-'
                        }
                        else {
                            new_profile.OxiRate = profile.Patient_Data.breathing.oxygen_flow_rate[profile.Patient_Data.breathing.oxygen_flow_rate.length - 1].y;
                        }
                        if (profile.Patient_Data.breathing === undefined || profile.Patient_Data.breathing.oxi_usage === undefined || profile.Patient_Data.breathing.oxi_usage.length === 0) {
                            new_profile.OxiUsage = '-'
                        }
                        else {
                            new_profile.OxiUsage = profile.Patient_Data.breathing.oxi_usage[profile.Patient_Data.breathing.oxi_usage.length - 1].y;
                        }
                        break

                    //Healthforms cases
                    //EQ5D
                    case "eq5d":
                        if (profile.Patient_Data[key] === undefined || profile.Patient_Data[key].healthscale === undefined || profile.Patient_Data[key].healthscale.length === 0) {
                            new_profile.EQ5DHealthscale = '-'
                        }
                        else {
                            new_profile.EQ5DHealthscale = profile.Patient_Data[key].healthscale[profile.Patient_Data[key].healthscale.length - 1].y;
                        }
                    //SF36
                    case "sf36":
                    //MDASI
                    case "mdasi":
                    //Alimentation
                    case "alimentation":
                        gridKey = keyConverter(key)
                        if (profile.Patient_Data[key] === undefined || profile.Patient_Data[key].form_res === undefined || profile.Patient_Data[key].form_res.length === 0) {
                            new_profile[gridKey] = '-'
                        }
                        else {
                            new_profile[gridKey] = profile.Patient_Data[key].form_res[profile.Patient_Data[key].form_res.length - 1].y;
                        }
                        break
                    default:
                        break
                }
            })

            // Compute alertCount for sorting
            let alertCount = 0;
            const alerts = profile.Patient_Data.alerts;
            if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("thermometer"))) {
                if (alerts.fever_alert.activated === true && Utils.dataAlertColor(new_profile.tuckyTemperature, 'tuckyTemperature', alerts.fever_alert.threshold, alerts.fever_alert.threshold2) === "#DB2828") alertCount++;
                if (alerts.pos_alert.triggered === true) alertCount++;
            }
            if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("oximeter"))) {
                if (alerts.PR_alert.activated === true && Utils.dataAlertColor(new_profile.oximeterPulseRate, 'oximeterPulseRate', alerts.PR_alert.threshold, alerts.PR_alert.threshold2) === "#DB2828") alertCount++;
                if (alerts.SPO2_alert.activated === true && Utils.dataAlertColor(new_profile.oximeterSPO2, 'oximeterSPO2', alerts.SPO2_alert.threshold, alerts.SPO2_alert.threshold2) === "#DB2828") alertCount++;
            }
            if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("tensiometer"))) {
                if (alerts.bloodpressure_PR_alert.activated === true && Utils.dataAlertColor(new_profile.tensiometerPulseRate, 'tensiometerPulseRate', alerts.bloodpressure_PR_alert.threshold, alerts.bloodpressure_PR_alert.threshold2) === "#DB2828") alertCount++;
                if (alerts.bloodpressure_sys_high_alert.activated === true && Utils.dataAlertColor(new_profile.tensiometerBloodpressure, 'tensiometerBloodpressure', alerts.bloodpressure_sys_high_alert.threshold, alerts.bloodpressure_sys_high_alert.threshold2) === "#DB2828") alertCount++;
            }
            if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("scale"))) {
                if (alerts.weight_alert.activated === true && Utils.dataAlertColor(new_profile.scaleWeight, 'scaleWeight', alerts.weight_alert.threshold, alerts.weight_alert.threshold2) === "#DB2828") alertCount++;
            }
            if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("niv"))) {
                if (alerts.breathing_observance_alert.activated === true && Utils.dataAlertColor(new_profile.NIVUsage, 'NIVUsage', alerts.breathing_observance_alert.threshold, alerts.breathing_observance_alert.threshold2) === "#DB2828") alertCount++;
                if (alerts.breathing_leakage_alert.activated === true && Utils.dataAlertColor(new_profile.NIVLeak, 'NIVLeak', alerts.breathing_leakage_alert.threshold, alerts.breathing_leakage_alert.threshold2) === "#DB2828") alertCount++;
                if (alerts.breathing_rate_alert.activated === true && Utils.dataAlertColor(new_profile.NIVRate, 'NIVRate', alerts.breathing_rate_alert.threshold, alerts.breathing_rate_alert.threshold2) === "#DB2828") alertCount++;
            }
            if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("oxigen_therapy"))) {
                if (alerts.breathing_oxygen_rate_alert.activated === true && Utils.dataAlertColor(new_profile.OxiRate, 'OxiRate', alerts.breathing_oxygen_rate_alert.threshold, alerts.breathing_oxygen_rate_alert.threshold2) === "#DB2828") alertCount++;
            }
            if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("pain"))) {
                if (alerts.pain_alert.activated === true && Utils.dataAlertColor(new_profile.pain, 'pain', alerts.pain_alert.threshold, alerts.pain_alert.threshold2) === "#DB2828") alertCount++;
            }
            if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_EQ5D"))) {
                if (alerts.eq5d_alert.activated === true && Utils.dataAlertColor(new_profile.EQ5D, 'EQ5D', alerts.eq5d_alert.threshold, alerts.eq5d_alert.threshold2) === "#DB2828") alertCount++;
                if (alerts.eq5d_scale_alert.activated === true && Utils.dataAlertColor(new_profile.EQ5DHealthscale, 'EQ5DHealthscale', alerts.eq5d_scale_alert.threshold, alerts.eq5d_scale_alert.threshold2) === "#DB2828") alertCount++;
            }
            if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_SF36"))) {
                if (alerts.sf36_alert.activated === true && Utils.dataAlertColor(new_profile.SF36, 'SF36', alerts.sf36_alert.threshold, alerts.sf36_alert.threshold2) === "#DB2828") alertCount++;
            }
            if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_MDASI"))) {
                if (alerts.mdasi_alert.activated === true && Utils.dataAlertColor(new_profile.MDASI, 'MDASI', alerts.mdasi_alert.threshold, alerts.mdasi_alert.threshold2) === "#DB2828") alertCount++;
            }
            new_profile.alertCount = alertCount;

            // Compute alertCount based on unacknowledged triggered alerts (same logic as PatientProfileModal)
            const alertsTriggered = profile.Patient_Data.alerts_triggered;
            const activeTriggeredAlerts = (alertsTriggered && Array.isArray(alertsTriggered))
                ? alertsTriggered.filter(a => !a.received)
                : [];
            new_profile.alertCount = activeTriggeredAlerts.length > 0 ? activeTriggeredAlerts.length : null;

            // Total alerts since beginning
            new_profile.totalAlertCount = (profile.Patient_Data.alerts_triggered && Array.isArray(profile.Patient_Data.alerts_triggered)) ? profile.Patient_Data.alerts_triggered.length : 0;

            PatientDataList.push(new_profile)
        })

        // Sort comparator for numeric columns — always pushes '-' / null to the end
        const numericSortComparator = (a, b, cellParams1) => {
            const na = (a === '-' || a === null || a === undefined) ? null : Number(a);
            const nb = (b === '-' || b === null || b === undefined) ? null : Number(b);
            if (na === null && nb === null) return 0;
            if (na !== null && nb !== null) return na - nb;
            // MUI inverts the comparator result for DESC, so we must compensate
            const sortModel = cellParams1.api.getSortModel();
            const colSort = sortModel.find(s => s.field === cellParams1.field);
            const isDesc = colSort && colSort.sort === 'desc';
            if (na === null) return isDesc ? -1 : 1;
            return isDesc ? 1 : -1;
        };
        // Sort comparator for blood pressure "sys/dia" — always pushes '-' / null to the end
        const bloodpressureSortComparator = (a, b, cellParams1) => {
            const va = (a === '-' || a === null || a === undefined) ? null : Number(String(a).split('/')[0]);
            const vb = (b === '-' || b === null || b === undefined) ? null : Number(String(b).split('/')[0]);
            if (va === null && vb === null) return 0;
            if (va !== null && vb !== null) return va - vb;
            const sortModel = cellParams1.api.getSortModel();
            const colSort = sortModel.find(s => s.field === cellParams1.field);
            const isDesc = colSort && colSort.sort === 'desc';
            if (va === null) return isDesc ? -1 : 1;
            return isDesc ? 1 : -1;
        };

        const showTlsCols = shouldShowTls(
            this.props.accountInformation,
            this.props.subscription_info?.features
        );
        const { page, pageSize } = this.state.paginationModel;
        const currentPageRows = PatientDataList.slice(page * pageSize, (page + 1) * pageSize);
        const canValidateAllPatientsTls = canValidateAllTls(
            this.props.accountInformation,
            this.props.subscription_info?.features,
            currentPageRows
        );

        let GridColDefList = [
            { field: 'patientName', headerName: this.props.intl.formatMessage({ id: "patient.name", defaultMessage: "Patient Name" }), 
                description: <div style={{fontSize:13}}><FormattedMessage id="patient.name" defaultMessage="Patient Name"/></div>,
                headerAlign: "center", width: 250,
                renderCell: (params) => {
                    let birthdateStr = '';
                    if (!this.props.accountInformation.anonymised_patient && params.row.patientBirthdate) {
                        const d = new Date(params.row.patientBirthdate);
                        if (!isNaN(d.getTime())) {
                            birthdateStr = d.toLocaleDateString('fr-FR');
                        }
                    }
                    return (
                        <div style={{display: 'flex', flexDirection: 'column', justifyContent:'center', alignItems:'center', width:"100%", padding: '6px 0'}}>
                            <div style={{fontWeight: "bold", display: 'flex', justifyContent:'center', alignItems:'center', color: '#1976d2', textDecoration: 'underline', cursor: 'pointer', gap: 6}}>
                                {!params.row.monitoringActive && (
                                    <span title="Suivi inactif" style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', backgroundColor: '#f44336', flexShrink: 0, boxShadow: '0 0 4px rgba(244,67,54,0.6)' }} />
                                )}
                                {params.formattedValue}
                                {userIsSuperAdmin(this.props.accountInformation) && !this.props.hidePatientIds && (
                                    <CopyableId value={params.row.id_patient} label="id_patient" />
                                )}
                            </div>
                            {birthdateStr && (
                                <span style={{
                                    fontSize: 11,
                                    color: '#546e7a',
                                    backgroundColor: '#e8f0f7',
                                    borderRadius: 10,
                                    padding: '2px 8px',
                                    marginTop: 5,
                                    letterSpacing: '0.3px',
                                    whiteSpace: 'nowrap',
                                }}>
                                    {birthdateStr}
                                </span>
                            )}
                        </div>
                    );
                },
             },
        ];
        if (this.props.accountInformation.readOnly !== true && this.props.accountInformation.anonymised_patient !== true) {
            GridColDefList.push({ field: 'userName', headerName: this.props.intl.formatMessage({ id: "user.name", defaultMessage: "User Name" }),
            description: <div style={{fontSize:13}}><FormattedMessage id="user.name" defaultMessage="User Name"/></div>,
            headerAlign: "center", width: 130 })
        }
        GridColDefList.push({
            field: 'alertCount',
            headerName: this.props.intl.formatMessage({ id: "patient.alertCount", defaultMessage: "Alertes en cours" }),
            description: <div style={{fontSize:13}}><FormattedMessage id="patient.alertCount" defaultMessage="Alertes en cours"/></div>,
            headerAlign: "center",
            width: 120,
            type: 'number',
            renderHeader: () => (
                <div style={{display: 'flex', flexDirection:'column', alignItems:'center', lineHeight: 1.2}}>
                    <span style={{fontSize: 10}}><FormattedMessage id="patient.list.activeAlertsLine1" defaultMessage="Active"/></span>
                    <span style={{fontSize: 10}}><FormattedMessage id="patient.list.activeAlertsLine2" defaultMessage="alerts"/></span>
                    <span style={{fontSize: 16}}>⚠</span>
                </div>
            ),
            getSortComparator: (sortDirection) => (a, b) => {
                const aNull = a == null;
                const bNull = b == null;
                if (aNull && bNull) return 0;
                if (aNull) return 1;
                if (bNull) return -1;
                return sortDirection === 'asc' ? a - b : b - a;
            },
            renderCell: (params) => (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    color: params.value > 0 ? '#DB2828' : '#767676',
                    fontWeight: params.value > 0 ? 'bold' : 'normal',
                    fontSize: 16,
                }}>
                    {params.value > 0 ? `⚠ ${params.value}` : '-'}
                </div>
            ),
        });
        if (showTlsCols) {
        GridColDefList.push({
            field: 'checkPatient',
            headerName: '',
            description: <div style={{fontSize:13}}><FormattedMessage id="patient.list.verify" defaultMessage="Verify"/></div>,
            headerAlign: "center",
            align: "center",
            width: 100,
            sortable: false,
            filterable: false,
            renderHeader: () => (
                <div style={{display: 'flex', flexDirection:'column', alignItems:'center', width:"100%"}}>
                    <span style={{fontSize: 12}}><FormattedMessage id="patient.list.verify" defaultMessage="Verify"/></span>
                    {canValidateAllPatientsTls && (
                        <Tooltip
                            title={<FormattedMessage id="patient.list.verifyAllTooltip" defaultMessage="All pneumology-monitored patients on this page will be validated" />}
                            placement="top"
                        >
                            <div style={{display:'flex', alignItems:'center', cursor:'pointer'}}
                                onClick={(e) => { e.stopPropagation(); this.requestCheckAllPatients(currentPageRows); }}
                            >
                                <CheckCircleIcon sx={{color: this.state.all_checked ? '#4caf50' : '#bdbdbd', fontSize: 18, mr: '2px', transition: 'color 0.2s ease'}} />
                                <span style={{fontSize: 10}}><FormattedMessage id="patient.list.verifyAll" defaultMessage="All"/></span>
                            </div>
                        </Tooltip>
                    )}
                </div>
            ),
            renderCell: (params) => (
                <div style={{display: 'flex', justifyContent:'center', alignItems:'center', width:"100%", height:"100%"}}>
                    {this.isTlsAuthorizedForPatient(params.row) && (
                        !params.row.monitoringActive ? (
                        <Tooltip
                            title={this.props.intl.formatMessage({ id: 'patient.list.tlsNoActiveMonitoringTooltip', defaultMessage: 'TLS not possible: the patient has no active monitoring' })}
                            placement="top"
                        >
                            <span>
                                <IconButton size="small" disabled>
                                    <CheckCircleIcon sx={{
                                        color: '#DB2828',
                                        fontSize: 26,
                                        transition: 'color 0.2s ease'
                                    }} />
                                </IconButton>
                            </span>
                        </Tooltip>
                        ) : (
                    <IconButton
                        size="small"
                        onClick={(e) => { e.stopPropagation(); this.requestCheckPatient(params.row.id_patient); }}
                    >
                        <CheckCircleIcon sx={{
                            color: (() => {
                                if (params.row.is_checked) return '#4caf50';
                                if (!params.row.check_patient_deadline) return '#bdbdbd';
                                const daysLeft = (new Date(params.row.check_patient_deadline).getTime() - Date.now()) / (1000 * 60 * 60 * 24);
                                if (daysLeft <= 0) return '#DB2828';
                                if (daysLeft <= 5) return '#f57c00';
                                if (daysLeft <= 10) return '#f57c00';
                                return '#4caf50';
                            })(),
                            fontSize: 26,
                            transition: 'color 0.2s ease'
                        }} />
                    </IconButton>
                        )
                    )}
                </div>
            ),
        })
        GridColDefList.push({
            field: 'check_patient_last',
            headerName: '',
            description: <div style={{fontSize:13}}><FormattedMessage id="patient.list.lastVerificationLine1" defaultMessage="Last date"/>{" "}<FormattedMessage id="patient.list.lastVerificationLine2" defaultMessage="TS physician"/></div>,
            headerAlign: "center",
            width: 140,
            sortable: true,
            filterable: false,
            renderHeader: () => (
                <div style={{display: 'flex', flexDirection:'column', alignItems:'center', lineHeight: 1.2}}>
                    <span style={{fontSize: 12}}><FormattedMessage id="patient.list.lastVerificationLine1" defaultMessage="Last date"/></span>
                    <span style={{fontSize: 12}}><FormattedMessage id="patient.list.lastVerificationLine2" defaultMessage="TS physician"/></span>
                </div>
            ),
            renderCell: (params) => {
                if (!params.value) return <div style={{display:'flex', justifyContent:'center', alignItems:'center', width:"100%", color:"#767676"}}>-</div>;
                const d = new Date(params.value);
                const datePart = d.toLocaleDateString();
                const timePart = d.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'});
                const userName = params.row.check_patient_user_name || '';
                const structureName = params.row.check_patient_structure_name || '';
                const tooltipTitle = structureName ? `${userName} (${structureName})` : userName;
                const parts = userName.trim().split(/\s+/);
                const initials = parts.length >= 2
                    ? (parts[0][0] + '.' + parts[parts.length - 1][0]).toUpperCase()
                    : (parts[0] ? parts[0][0].toUpperCase() : '');
                return (
                    <div style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', width:"100%", lineHeight: '1.2'}}>
                        <span style={{fontSize: 13}}>{datePart}</span>
                        <span style={{fontSize: 12, color: '#444'}}>{timePart}</span>
                        {initials && <Tooltip title={tooltipTitle} placement="top"><span style={{fontSize: 11, color: '#888', fontWeight:'bold'}}>{initials}</span></Tooltip>}
                    </div>
                );
            },
        })
        GridColDefList.push({
            field: 'check_patient_deadline',
            headerName: '',
            description: <div style={{fontSize:13}}><FormattedMessage id="patient.list.deadlineLine1" defaultMessage="TS to validate"/>{" "}<FormattedMessage id="patient.list.deadlineLine2" defaultMessage="at the latest"/></div>,
            headerAlign: "center",
            width: 130,
            sortable: true,
            filterable: false,
            renderHeader: () => (
                <div style={{display: 'flex', flexDirection:'column', alignItems:'center', lineHeight: 1.2}}>
                    <span style={{fontSize: 12}}><FormattedMessage id="patient.list.deadlineLine1" defaultMessage="TS to validate"/></span>
                    <span style={{fontSize: 12}}><FormattedMessage id="patient.list.deadlineLine2" defaultMessage="at the latest"/></span>
                </div>
            ),
            renderCell: (params) => {
                if (!params.value) return <div style={{display:'flex', justifyContent:'center', alignItems:'center', width:"100%", color:"#767676"}}>-</div>;
                const deadline = new Date(params.value);
                const now = new Date();
                const daysLeft = (deadline - now) / (1000 * 60 * 60 * 24);
                let color = '#767676';
                let fontWeight = 'normal';
                if (daysLeft <= 0) {
                    color = '#DB2828';
                    fontWeight = 'bold';
                } else if (daysLeft <= 5) {
                    color = '#f57c00';
                    fontWeight = 'bold';
                } else if (daysLeft <= 10) {
                    color = '#f57c00';
                } else {
                    color = '#4caf50';
                }
                const datePart = deadline.toLocaleDateString();
                const daysRounded = Math.ceil(Math.abs(daysLeft));
                const tooltipText = daysLeft <= 0
                    ? this.props.intl.formatMessage({ id: 'patient.list.deadlineTooltipOverdue', defaultMessage: 'TLS overdue by {days}d' }, { days: daysRounded })
                    : this.props.intl.formatMessage({ id: 'patient.list.deadlineTooltip', defaultMessage: 'Next TLS maximum in {days}d' }, { days: daysRounded });
                return (
                    <Tooltip title={tooltipText} placement="top">
                        <div style={{display:'flex', justifyContent:'center', alignItems:'center', width:"100%", color: color, fontWeight: fontWeight, fontSize: 13}}>
                            {datePart}
                        </div>
                    </Tooltip>
                );
            },
        })
        } // end showTlsCols
        GridColDefList.push({
            field: 'totalAlertCount',
            headerName: this.props.intl.formatMessage({ id: "patient.totalAlertCount", defaultMessage: "NB alertes depuis début" }),
            description: <div style={{fontSize:13}}>Nombre total d'alertes depuis le début</div>,
            headerAlign: "center",
            width: 180,
            type: 'number',
            sortComparator: numericSortComparator,
            renderCell: (params) => (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    color: '#767676',
                    fontSize: 16,
                }}>
                    {params.value !== undefined && params.value !== null ? params.value : '-'}
                </div>
            ),
        });
        let GridColumnGroupingModelList = []

        //Tucky data
        if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("thermometer"))) {
            //Temperature
            GridColDefList.push({ 
                field: 'tuckyTemperature', 
                headerName: '',
                renderHeader: () => (<Icon name="thermometer half" size={this.state.temperatureSize}/>),
                description: <div style={{fontSize:13}}><FormattedMessage id="patientConstants.temperature" defaultMessage="Temperature"/></div>,
                width: 110, 
                headerAlign: "center",
                type: 'number',
                sortComparator: numericSortComparator,
                renderCell: (params: GridRenderCellParams<any, Date>) => (
                    <div
                      style={{
                        color: Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.fever_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.fever_alert.threshold2),
                        backgroundColor: (this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.fever_alert.activated === true && Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.fever_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.fever_alert.threshold2) === "#DB2828") ? "yellow" : "#11ffee00",
                        display: 'flex',
                        justifyContent:'center',
                        alignItems:'center', 
                        fontSize: 20,
                      }}
                    >
                        {Utils.formatDataDisplay("fever_alert", params.value)}
                    </div>
                ),
            })
            //Position
            GridColDefList.push({ 
                field: 'tuckyPosition', 
                headerName: '',
                renderHeader: () => (<img
                    src={stand_alert}
                    style={{ height: this.state.positionSize, maxHeight: "100%", width: "100%", maxWidth: "100%"}}
                    alt="position-stand-alert"  
                />), 
                width: 100,
                description: <div style={{fontSize:13}}><FormattedMessage id="param.position" defaultMessage="Position"/></div>,
                headerAlign: "center",
                renderCell: (params: GridRenderCellParams<any, Date>) => (
                    <div
                      style={{
                        backgroundColor: (this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.pos_alert.triggered === true) ? "yellow" : "#11ffee00",
                        display: 'flex',
                        justifyContent:'center',
                        alignItems:'center', 
                        fontSize: 20
                      }}
                    >
                        {Utils.formatDataDisplay("state", params.value)}
                    </div>
                ),
             })
            //Grouping
            GridColumnGroupingModelList.push(
                {
                    groupId: 'TUCKY',
                    headerAlign: "center",
                    renderHeaderGroup: (params) => (
                        <div style={{fontWeight: "bold", display: 'flex', justifyContent:'center', alignItems:'center', width:"100%"}}>
                            {params.groupId}
                        </div>
                    ),
                    children: [
                        { 
                            field: 'tuckyTemperature',
                        },
                        { 
                            field: 'tuckyPosition' 
                        },
                    ],
                },
            )
        }

        //Oximeter data
        if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("oximeter"))) {
            //Pulse rate
            GridColDefList.push({ 
                field: 'oximeterPulseRate', 
                headerName: '',
                renderHeader: () => (<Icon name='heartbeat' size={this.state.heartrateOximeterSize}/>), 
                description: <div style={{fontSize:13}}><FormattedMessage id="patientConstants.heartRate" defaultMessage="Heart rate"/></div>,
                headerAlign: "center",
                width: 135,
                type: 'number',
                sortComparator: numericSortComparator,
                renderCell: (params: GridRenderCellParams<any, Date>) => (
                    <div
                      style={{
                        color: Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.PR_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.PR_alert.threshold2),
                        backgroundColor: (this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.PR_alert.activated === true && Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.PR_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.PR_alert.threshold2) === "#DB2828") ? "yellow" : "#11ffee00",
                        display: 'flex',
                        justifyContent:'center',
                        alignItems:'center', 
                        fontSize: 20,
                      }}
                    >
                        {Utils.formatDataDisplay("PR_alert", params.value)}
                    </div>
                ),
            })
            //SPO2
            GridColDefList.push({ 
                field: 'oximeterSPO2', 
                headerName: '',
                renderHeader: () => (<img src={SPO2_grey} style={{ height: "auto", maxHeight: "100%", width: "50px", maxWidth: "100%"}} alt="SPO2_logo"/>), 
                description: <div style={{fontSize:13}}><FormattedMessage id="patientConstants.spo2" defaultMessage="SPO2"/></div>,
                headerAlign: "center",
                width: 120,
                type: 'number',
                sortComparator: numericSortComparator,
                renderCell: (params: GridRenderCellParams<any, Date>) => (
                    <div
                      style={{
                        color: Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.SPO2_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.SPO2_alert.threshold2),
                        backgroundColor: (this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.SPO2_alert.activated === true && Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.SPO2_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.SPO2_alert.threshold2) === "#DB2828") ? "yellow" : "#11ffee00",
                        display: 'flex',
                        justifyContent:'center',
                        alignItems:'center', 
                        fontSize: 20,
                      }}
                    >
                        {Utils.formatDataDisplay("SPO2_alert", params.value)}
                    </div>
                ),
            })
            //Grouping
            GridColumnGroupingModelList.push(
                {
                    groupId: 'Oximeter',
                    headerName: <FormattedMessage id="patient.list.oximeter.title" defaultMessage="OXIMETER"/>,
                    headerAlign: "center",
                    renderHeaderGroup: (params) => (
                        <div style={{fontWeight: "bold", display: 'flex', justifyContent:'center', alignItems:'center', width:"100%"}}>
                            {params.headerName}
                        </div>
                    ),
                    children: [
                        { 
                            field: 'oximeterPulseRate',
                        },
                        { 
                            field: 'oximeterSPO2' 
                        },
                    ],
                },
            )
        }

        //Tensiometer data
        if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("tensiometer"))) {
            //Pulse rate
            GridColDefList.push({ 
                field: 'tensiometerPulseRate',
                headerName: '',
                renderHeader: () => (<Icon name='heartbeat' size={this.state.heartrateTensiometerSize}/>),
                description: <div style={{fontSize:13}}><FormattedMessage id="patientConstants.heartRate" defaultMessage="Heart rate"/></div>,
                headerAlign: "center",
                width: 135,
                type: 'number',
                sortComparator: numericSortComparator,
                renderCell: (params: GridRenderCellParams<any, Date>) => (
                    <div
                      style={{
                        color: Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.bloodpressure_PR_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.bloodpressure_PR_alert.threshold2),
                        backgroundColor: (this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.bloodpressure_PR_alert.activated === true && Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.bloodpressure_PR_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.bloodpressure_PR_alert.threshold2) === "#DB2828") ? "yellow" : "#11ffee00",
                        display: 'flex',
                        justifyContent:'center',
                        alignItems:'center', 
                        fontSize: 20,
                      }}
                    >
                        {Utils.formatDataDisplay("bloodpressure_PR_alert", params.value)}
                    </div>
                ),
            })
            //Bloodpressure
            GridColDefList.push({ 
                field: 'tensiometerBloodpressure',
                headerName: '',
                renderHeader: () => (<img src={bloodPressure_grey} style={{ height: "auto", maxHeight: "100%", width: "50px", maxWidth: "100%"}} alt="Bloodpressure_logo"/>),
                description: <div style={{fontSize:13}}><FormattedMessage id="patientConstants.pressureBlood" defaultMessage="Bloodpressure"/></div>,
                headerAlign: "center",
                width: 135,
                sortComparator: bloodpressureSortComparator,
                renderCell: (params: GridRenderCellParams<any, Date>) => (
                    <div
                      style={{
                        color: Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.bloodpressure_sys_high_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.bloodpressure_sys_high_alert.threshold2),
                        backgroundColor: (this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.bloodpressure_sys_high_alert.activated === true && Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.bloodpressure_sys_high_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.bloodpressure_sys_high_alert.threshold2) === "#DB2828") ? "yellow" : "#11ffee00",
                        display: 'flex',
                        justifyContent:'center',
                        alignItems:'center', 
                        fontSize: 20,
                      }}
                    >
                        {Utils.formatDataDisplay("bloodpressure_sys_high_alert", params.value)}
                    </div>
                ),
            })
            //Grouping
            GridColumnGroupingModelList.push(
                {
                    groupId: 'Tensiometer',
                    headerName: <FormattedMessage id="patient.list.tensiometer.title" defaultMessage="TENSIOMETER"/>,
                    headerAlign: "center",
                    renderHeaderGroup: (params) => (
                        <div style={{fontWeight: "bold", display: 'flex', justifyContent:'center', alignItems:'center', width:"100%"}}>
                            {params.headerName}
                        </div>
                    ),
                    children: [
                        { 
                            field: 'tensiometerPulseRate',
                        },
                        { 
                            field: 'tensiometerBloodpressure' 
                        },
                    ],
                },
            )
        }

        //Scale data
        if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("scale"))) {
            //Weight
            GridColDefList.push({ 
                field: 'scaleWeight',
                headerName: '',
                renderHeader: () => (<img src={weight_grey} style={{ height: "auto", maxHeight: "100%", width: "50px", maxWidth: "100%"}} alt="Weight_logo"/>),
                description: <div style={{fontSize:13}}><FormattedMessage id="patientConstants.weight" defaultMessage="Weight"/></div>,
                headerAlign: "center",
                width: 135,
                type: 'number',
                sortComparator: numericSortComparator,
                renderCell: (params: GridRenderCellParams<any, Date>) => (
                    <div
                      style={{
                        color: Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.weight_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.weight_alert.threshold2),
                        backgroundColor: (this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.weight_alert.activated === true && Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.weight_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.weight_alert.threshold2) === "#DB2828") ? "yellow" : "#11ffee00",
                        display: 'flex',
                        justifyContent:'center',
                        alignItems:'center', 
                        fontSize: 20,
                      }}
                    >
                        {Utils.formatDataDisplay("weight_alert", params.value)}
                    </div>
                ),
            })
            //Grouping
            GridColumnGroupingModelList.push(
                {
                    groupId: 'Scale',
                    headerName: <FormattedMessage id="patient.list.scale.title" defaultMessage="SCALE"/>,
                    headerAlign: "center",
                    renderHeaderGroup: (params) => (
                        <div style={{fontWeight: "bold", display: 'flex', justifyContent:'center', alignItems:'center', width:"100%"}}>
                            {params.headerName}
                        </div>
                    ),
                    children: [
                        { 
                            field: 'scaleWeight',
                        },
                    ],
                },
            )
        }

        //NIV data
        if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("niv"))) {
            //Breathing usage
            GridColDefList.push({
                field: 'NIVUsage',
                headerName: '',
                renderHeader: () => (<Icon name="clock" size={this.state.usageNivSize}/>),
                description: <div style={{fontSize:13}}><FormattedMessage id="breathing.niv.usage" defaultMessage="NIV usage"/></div>,
                headerAlign: "center",
                width: 135,
                type: 'number',
                sortComparator: numericSortComparator,
                renderCell: (params: GridRenderCellParams<any, Date>) => (
                    <div
                      style={{
                        color: Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.breathing_observance_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.breathing_observance_alert.threshold2),
                        backgroundColor: (this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.breathing_observance_alert.activated === true && Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.breathing_observance_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.breathing_observance_alert.threshold2) === "#DB2828") ? "yellow" : "#11ffee00",
                        display: 'flex',
                        justifyContent:'center',
                        alignItems:'center', 
                        fontSize: 20,
                      }}
                    >
                        {Utils.formatDataDisplay("breathing_observance_alert", params.value)}
                    </div>
                ),
            })
            //Breathing leakage
            GridColDefList.push({
                field: 'NIVLeak',
                headerName: '',
                renderHeader: () => (<img src={img_leakage} style={{ height: "auto", maxHeight: "100%", width: "60px", maxWidth: "100%"}} alt="oxygentherapy_logo"/>),
                description: <div style={{fontSize:13}}><FormattedMessage id="param.breathingLeakageAlert" defaultMessage="Leakage"/></div>,
                headerAlign: "center",
                width: 135,
                type: 'number',
                sortComparator: numericSortComparator,
                renderCell: (params: GridRenderCellParams<any, Date>) => (
                    <div
                      style={{
                        color: Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.breathing_leakage_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.breathing_leakage_alert.threshold2),
                        backgroundColor: (this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.breathing_leakage_alert.activated === true && Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.breathing_leakage_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.breathing_leakage_alert.threshold2) === "#DB2828") ? "yellow" : "#11ffee00",
                        display: 'flex',
                        justifyContent:'center',
                        alignItems:'center', 
                        fontSize: 20,
                      }}
                    >
                        {Utils.formatDataDisplay("breathing_leakage_alert", params.value)}
                    </div>
                ),
            })
            //Breathing rate
            GridColDefList.push({
                field: 'NIVRate',
                headerName: '',
                renderHeader: () => (<img src={img_vni} style={{ height: "auto", maxHeight: "100%", width: "70px", maxWidth: "100%"}} alt="niv_logo"/>),
                description: <div style={{fontSize:13}}><FormattedMessage id="param.breathingAlert" defaultMessage="Breathing rate"/></div>,
                headerAlign: "center",
                width: 130,
                type: 'number',
                sortComparator: numericSortComparator,
                renderCell: (params: GridRenderCellParams<any, Date>) => (
                    <div
                      style={{
                        color: Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.breathing_rate_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.breathing_rate_alert.threshold2),
                        backgroundColor: (this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.breathing_rate_alert.activated === true && Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.breathing_rate_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.breathing_rate_alert.threshold2) === "#DB2828") ? "yellow" : "#11ffee00",
                        display: 'flex',
                        justifyContent:'center',
                        alignItems:'center', 
                        fontSize: 20,
                      }}
                    >
                        {Utils.formatDataDisplay("breathing_rate_alert", params.value)}
                    </div>
                ),
            })
            //Grouping
            GridColumnGroupingModelList.push(
                {
                    groupId: 'NIV',
                    headerName: <FormattedMessage id="patient.list.niv.title" defaultMessage="NON-INVASIVE VENTILATION"/>,
                    headerAlign: "center",
                    renderHeaderGroup: (params) => (
                        <div style={{fontWeight: "bold", display: 'flex', justifyContent:'center', alignItems:'center', width:"100%"}}>
                            {params.headerName}
                        </div>
                    ),
                    children: [
                        { 
                            field: 'NIVUsage',
                        },
                        { 
                            field: 'NIVLeak',
                        },
                        { 
                            field: 'NIVRate',
                        },
                    ],
                },
            )
        }

        //Oxigen therapy data
        if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("oxigen_therapy"))) {
            //Oxigen therapy usage
            GridColDefList.push({
                field: 'OxiUsage',
                headerName: '',
                renderHeader: () => (<Icon name="clock" size={this.state.usageOxigentherapySize}/>),
                description: <div style={{fontSize:13}}><FormattedMessage id="breathing.oxygen_therapy.usage" defaultMessage="Oxygen therapy usage"/></div>,
                headerAlign: "center",
                width: 135,
                type: 'number',
                sortComparator: numericSortComparator,
                renderCell: (params: GridRenderCellParams<any, Date>) => (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent:'center',
                        alignItems:'center', 
                        fontSize: 20,
                      }}
                    >
                        {Utils.formatDataDisplay("breathing_observance_alert", params.value)}
                    </div>
                ),
            })
            //Oxygen flow rate
            GridColDefList.push({
                field: 'OxiRate',
                headerName: '',
                renderHeader: () => (<img src={img_oxygentherapy} style={{ height: "auto", maxHeight: "100%", width: "60px", maxWidth: "100%"}} alt="oxygentherapy_logo"/>),
                description: <div style={{fontSize:13}}><FormattedMessage id="patientConstants.oxigenFlowRate" defaultMessage="Oxigen flow"/></div>,
                headerAlign: "center",
                width: 120,
                type: 'number',
                sortComparator: numericSortComparator,
                renderCell: (params: GridRenderCellParams<any, Date>) => (
                    <div
                      style={{
                        color: Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.breathing_oxygen_rate_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.breathing_oxygen_rate_alert.threshold2),
                        backgroundColor: (this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.breathing_oxygen_rate_alert.activated === true && Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.breathing_oxygen_rate_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.breathing_oxygen_rate_alert.threshold2) === "#DB2828") ? "yellow" : "#11ffee00",
                        display: 'flex',
                        justifyContent:'center',
                        alignItems:'center', 
                        fontSize: 20,
                      }}
                    >
                        {Utils.formatDataDisplay("breathing_oxigen_rate_alert", params.value)}
                    </div>
                ),
            })
            //Grouping
            GridColumnGroupingModelList.push(
                {
                    groupId: 'Oxigen therapy',
                    headerName: <FormattedMessage id="patient.list.oxigentherapy.title" defaultMessage="OXIGEN THERAPY"/>,
                    headerAlign: "center",
                    renderHeaderGroup: (params) => (
                        <div style={{fontWeight: "bold", display: 'flex', justifyContent:'center', alignItems:'center', width:"100%"}}>
                            {params.headerName}
                        </div>
                    ),
                    children: [
                        { 
                            field: 'OxiUsage',
                        },
                        { 
                            field: 'OxiRate',
                        },
                    ],
                },
            )
        }

        //Healthform data grouping
        if (
                (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("pain")))
            ||  (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_EQ5D")))
            ||  (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_SF36")))
            ||  (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_MDASI")))
            ||  (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_ALIMENTATION")))
            ) {
            //Grouping
            GridColumnGroupingModelList.push(
                {
                    groupId: 'Healthforms',
                    headerName: <FormattedMessage id="patient.list.healthforms.title" defaultMessage="HEALTHFORMS"/>,
                    headerAlign: "center",
                    renderHeaderGroup: (params) => (
                        <div style={{fontWeight: "bold", display: 'flex', justifyContent:'center', alignItems:'center', width:"100%"}}>
                            {params.headerName}
                        </div>
                    ),
                    children: [
                        { 
                            field: 'pain',
                        },
                        { 
                            field: 'EQ5D',
                        },
                        { 
                            field: 'EQ5DHealthscale',
                        },
                        { 
                            field: 'SF36',
                        },
                        { 
                            field: 'MDASI',
                        },
                        { 
                            field: 'Alimentation',
                        },
                    ],
                },
            )
        }

        //Pain data
        if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("pain"))) {
            //Pain
            GridColDefList.push({ 
                field: 'pain',
                headerName: '',
                renderHeader: () => (<GiBackPain  size={this.state.painSize}/>),
                description: <div style={{fontSize:13}}><FormattedMessage id="patientConstants.pain" defaultMessage="Pain"/></div>,
                headerAlign: "center",
                width: 120,
                type: 'number',
                sortComparator: numericSortComparator,
                renderCell: (params: GridRenderCellParams<any, Date>) => (
                    <div
                      style={{
                        color: Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.pain_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.pain_alert.threshold2),
                        backgroundColor: (this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.pain_alert.activated === true && Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.pain_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.pain_alert.threshold2) === "#DB2828") ? "yellow" : "#11ffee00",
                        display: 'flex',
                        justifyContent:'center',
                        alignItems:'center', 
                        fontSize: 20,
                      }}
                    >
                        {params.value}
                    </div>
                ),
            })
        }

        //EQ5D data
        if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_EQ5D"))) {
            //EQ5D
            GridColDefList.push({ 
                field: 'EQ5D',
                headerName: '',
                renderHeader: () => (<img src={healthscale_grey} style={{ height: "auto", maxHeight: "100%", width: "60px", maxWidth: "100%"}} alt="healthsform_logo"/>),
                description: <div style={{fontSize:13}}>EQ5D</div>,
                headerAlign: "center",
                width: 115,
                type: 'number',
                sortComparator: numericSortComparator,
                renderCell: (params: GridRenderCellParams<any, Date>) => (
                    <div
                      style={{
                        color: Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.eq5d_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.eq5d_alert.threshold2),
                        backgroundColor: (this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.eq5d_alert.activated === true && Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.eq5d_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.eq5d_alert.threshold2) === "#DB2828") ? "yellow" : "#11ffee00",
                        display: 'flex',
                        justifyContent:'center',
                        alignItems:'center', 
                        fontSize: 20,
                      }}
                    >
                        {params.value}
                    </div>
                ),
            })
            //EQ5D scale
            GridColDefList.push({
                field: 'EQ5DHealthscale',
                headerName: '',
                renderHeader: () => (<img src={ruler_grey} style={{ height: "auto", maxHeight: "100%", width: "60px", maxWidth: "100%"}} alt="healthscale_logo"/>),
                description: <div style={{fontSize:13}}><FormattedMessage id="eq5d.healthscale" defaultMessage="EQ5D healthscale"/></div>,
                headerAlign: "center",
                width: 115,
                type: 'number',
                sortComparator: numericSortComparator,
                renderCell: (params: GridRenderCellParams<any, Date>) => (
                    <div
                      style={{
                        color: Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.eq5d_scale_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.eq5d_scale_alert.threshold2),
                        backgroundColor: (this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.eq5d_scale_alert.activated === true && Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.eq5d_scale_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.eq5d_scale_alert.threshold2) === "#DB2828") ? "yellow" : "#11ffee00",
                        display: 'flex',
                        justifyContent:'center',
                        alignItems:'center', 
                        fontSize: 20,
                      }}
                    >
                        {params.value}
                    </div>
                ),
            })
        }

        //SF36 data
        if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_SF36"))) {
            //SF36
            GridColDefList.push({
                field: 'SF36',
                headerName: '',
                renderHeader: () => (<TbFileSmile  size={this.state.healthformSF36Size}/>),
                description: <div style={{fontSize:13}}>SF36</div>,
                headerAlign: "center",
                width: 115,
                type: 'number',
                sortComparator: numericSortComparator,
                renderCell: (params: GridRenderCellParams<any, Date>) => (
                    <div
                      style={{
                        color: params.value === '-' ? "#767676" : "#21BA45",
                        backgroundColor: (this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.sf36_alert.activated === true && Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.sf36_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.sf36_alert.threshold2) === "#DB2828") ? "yellow" : "#11ffee00",
                        display: 'flex',
                        justifyContent:'center',
                        alignItems:'center', 
                        fontSize: 20,
                      }}
                    >
                        {Utils.formatDataDisplay("SF36", params.value)}
                    </div>
                ),
            })
        }

        //MDASI data
        if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_MDASI"))) {
            //MDASI
            //Value display to be updated
            GridColDefList.push({
                field: 'MDASI',
                headerName: '',
                renderHeader: () => (<LiaSmileWinkSolid  size={this.state.healthformMDASISize}/>),
                description: <div style={{fontSize:13}}>MDASI</div>,
                headerAlign: "center",
                width: 115,
                type: 'number',
                sortComparator: numericSortComparator,
                renderCell: (params: GridRenderCellParams<any, Date>) => (
                    <div
                      style={{
                        color: Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.mdasi_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.mdasi_alert.threshold2),
                        backgroundColor: (this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.mdasi_alert.activated === true && Utils.dataAlertColor(params.value, params.field, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.mdasi_alert.threshold, this.props.profilesInformation.find(e => e.Patient_Data.id_patient === params.row.id_patient).Patient_Data.alerts.mdasi_alert.threshold2) === "#DB2828") ? "yellow" : "#11ffee00",
                        display: 'flex',
                        justifyContent:'center',
                        alignItems:'center', 
                        fontSize: 20,
                      }}
                    >
                        {Utils.formatDataDisplay("MDASI", params.value)}
                    </div>
                ),
            })
        }

        //Alimentation data
        if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_ALIMENTATION"))) {
            //Alimentation
            //Value display to be updated
            GridColDefList.push({
                field: 'Alimentation',
                headerName: '',
                renderHeader: () => (<Icon name="utensils" size={this.state.healthformAlimentationSize}/>),
                description: <div style={{fontSize:13}}><FormattedMessage id="alimentation.title" defaultMessage="Nourishment"/></div>,
                headerAlign: "center",
                width: 120,
                type: 'number',
                sortComparator: numericSortComparator,
                renderCell: (params: GridRenderCellParams<any, Date>) => (
                    <div
                      style={{
                        color: params.value === '-' ? "#767676" : "#21BA45",
                        backgroundColor: "#11ffee00",
                        display: 'flex',
                        justifyContent:'center',
                        alignItems:'center', 
                        fontSize: 20,
                      }}
                    >
                        {Utils.formatDataDisplay("Alimentation", params.value)}
                    </div>
                ),
            })
        }

        const columns = GridColDefList

        const columnGroupingModel: GridColumnGroupingModel = GridColumnGroupingModelList

        const rows = PatientDataList

        const paginationModel = { page: 0, pageSize: 20 };

        // Responsive layout: cards on phones and tablets (incl. landscape, e.g. 1280px devices),
        // priority columns on small laptops, full grid on large screens
        const screenWidth = this.props.screenSize?.width ?? window.innerWidth;
        const layoutMode = screenWidth < 1300 ? 'cards' : screenWidth < 1600 ? 'tabletGrid' : 'desktopGrid';

        const alertColFields = ['alertCount', 'checkPatient', 'check_patient_last', 'check_patient_deadline', 'totalAlertCount'];
        const medicalColFields = ['tuckyTemperature', 'tuckyPosition', 'tensiometerPulseRate', 'tensiometerBloodpressure', 'EQ5D', 'EQ5DHealthscale', 'SF36', 'MDASI', 'scaleWeight'];
        const tabletPriorityFields = ['patientName', 'alertCount', 'checkPatient', 'check_patient_last', 'check_patient_deadline', 'tuckyTemperature', 'oximeterSPO2'];
        const columnVisibilityModel = {};
        if (layoutMode === 'tabletGrid' && !this.state.showAllColsTablet) {
            GridColDefList.forEach(col => {
                if (!tabletPriorityFields.includes(col.field)) columnVisibilityModel[col.field] = false;
            });
        }
        if (this.state.hideAlertCols) alertColFields.forEach(f => { columnVisibilityModel[f] = false; });
        if (this.state.hideMedicalCols) medicalColFields.forEach(f => { columnVisibilityModel[f] = false; });

        if (layoutMode === 'cards') {
            return (
                <div>
                    <PatientCardList
                        rows={rows}
                        getPatientAlerts={(id_patient) => this.props.profilesInformation.find(e => e.Patient_Data.id_patient === id_patient)?.Patient_Data.alerts}
                        onOpenProfile={this.openPatientProfile}
                        onOpenGraph={this.openMetricGraph}
                        onRequestCheckPatient={this.requestCheckPatient}
                        onVerifyAll={this.requestCheckAllPatients}
                        isTlsAuthorizedForPatient={this.isTlsAuthorizedForPatient}
                        showTlsCols={showTlsCols}
                        allChecked={this.state.all_checked}
                        subscriptionFeatures={this.props.subscription_info.features}
                        accountInformation={this.props.accountInformation}
                        hidePatientIds={this.props.hidePatientIds}
                        intl={this.props.intl}
                    />
                    {this.renderOverlays()}
                </div>
            );
        }

        return (
            <div>
                <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                    {layoutMode === 'tabletGrid' && (
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={() => this.setState(s => ({ showAllColsTablet: !s.showAllColsTablet }))}
                            style={{ textTransform: 'none', fontSize: 12, backgroundColor: 'white' }}
                        >
                            {this.state.showAllColsTablet
                                ? <FormattedMessage id="patient.list.priorityColumnsTablet" defaultMessage="Colonnes prioritaires" />
                                : <FormattedMessage id="patient.list.showAllColumnsTablet" defaultMessage="Toutes les colonnes" />}
                        </Button>
                    )}
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={() => this.setState(s => ({ hideAlertCols: !s.hideAlertCols }))}
                        style={{ textTransform: 'none', fontSize: 12, backgroundColor: 'white' }}
                    >
                        {this.state.hideAlertCols
                            ? <FormattedMessage id="patient.list.showAlertCols" defaultMessage="Afficher colonnes alertes" />
                            : <FormattedMessage id="patient.list.hideAlertCols" defaultMessage="Masquer colonnes alertes" />}
                    </Button>
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={() => this.setState(s => ({ hideMedicalCols: !s.hideMedicalCols }))}
                        style={{ textTransform: 'none', fontSize: 12, backgroundColor: 'white' }}
                    >
                        {this.state.hideMedicalCols
                            ? <FormattedMessage id="patient.list.showMedicalCols" defaultMessage="ALL" />
                            : <FormattedMessage id="patient.list.hideMedicalCols" defaultMessage="VNI seulement" />}
                    </Button>
                </div>
                <Paper sx={{ height: "100%", width: '100%' }}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        localeText={dataGridLocaleText(this.props.intl && this.props.intl.locale)}
                        initialState={{ pagination: { paginationModel }, sorting: { sortModel: [{ field: 'alertCount', sort: 'desc' }] } }}
                        pageSizeOptions={[20, 50, 100]}
                        columnGroupingModel={columnGroupingModel}
                        columnVisibilityModel={columnVisibilityModel}
                        onCellClick={this.handleCellClick}
                        getRowHeight={() => 'auto'}
                        sortingOrder={['asc', 'desc']}
                        onPaginationModelChange={(model) => this.setState({ paginationModel: model })}
                        sx={{
                            border: 0,
                            '& .MuiDataGrid-row': {
                                alignItems: 'stretch',
                            },
                            '& .MuiDataGrid-cell': {
                                borderRight: '1px solid #e0e0e0',
                                display: 'flex',
                                alignItems: 'center !important',
                                justifyContent: 'center',
                            },
                            '& .MuiDataGrid-cell--autoHeight': {
                                alignItems: 'center !important',
                            },
                            '& .MuiDataGrid-cell:not([data-field="patientName"])': {
                                padding: '6px',
                            },
                            '& .MuiDataGrid-cell:not([data-field="patientName"]) > div': {
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            },
                            '& .MuiDataGrid-row:nth-of-type(odd)': {
                                backgroundColor: '#f5f8fc',
                            },
                            '& .MuiDataGrid-row:nth-of-type(even)': {
                                backgroundColor: '#ffffff',
                            },
                            "& .MuiDataGrid-row:hover": {
                                backgroundColor: "#dce8f5 !important"
                            },
                            "& .MuiDataGrid-cell:hover": {
                                cursor: "pointer",
                            },
                        }}
                    />
                </Paper>
                {this.renderOverlays()}
            </div>
        );
    }

    // Modals, graph popups and the TLS confirm dialog — shared by the card and grid layouts
    renderOverlays() {
        return (
            <React.Fragment>
                {this.state.selectedPatientProfile && (
                    <PatientProfileModal
                        patientData={this.state.selectedPatientProfile}
                        cancelPopup={() => this.setState({ selectedPatientProfile: null })}
                        subscription_info={this.props.subscription_info}
                        tlsSubscriptionFeatures={this.props.subscription_info?.features}
                        dateSelected={this.props.dateSelected}
                        intl={this.props.intl}
                        accountInformation={this.props.accountInformation}
                        struct_info={this.props.struct_info}
                        hidePatientIds={this.props.hidePatientIds}
                        onAlertAck={(id_patient, alertId, ackTime) => {
                            const profile = this.props.profilesInformation.find(e => e.Patient_Data.id_patient === id_patient);
                            if (profile && Array.isArray(profile.Patient_Data.alerts_triggered)) {
                                const alert = profile.Patient_Data.alerts_triggered.find(a => a.identifier === alertId);
                                if (alert) alert.received = ackTime;
                            }
                            this.forceUpdate();
                        }}
                        onCheckPatientUpdate={(id_patient, updated) => {
                            this.setState(state => ({
                                check_patient_data: { ...state.check_patient_data, [id_patient]: updated },
                                checked_patients: { ...state.checked_patients, [id_patient]: true }
                            }));
                        }}
                    />
                )}
                {this.state.inside_props.map((inside, i) => {
                        return (
                    <GraphPopup
                            key={i}
                            inside_props={this.state.inside_props[i]}
                            onClose={() => this.handleGraphPopup(i)}
                    />
                        )
                    })
                }
                <Dialog
                    open={this.state.confirmDialogOpen}
                    onClose={this.handleConfirmDialogClose}
                >
                    <DialogTitle>
                        <FormattedMessage id="patient.list.verify" defaultMessage="TS Validation" />
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {this.state.confirmDialogType === 'all'
                                ? <FormattedMessage id="patient.list.verifyAllConfirm" defaultMessage="Are you sure you want to validate the remote monitoring for all patients on this page?" />
                                : <FormattedMessage id="patient.list.verifyConfirm" defaultMessage="Are you sure you want to validate the remote monitoring?" />
                            }
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleConfirmDialogClose} color="error">
                            <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
                        </Button>
                        <Button onClick={this.handleConfirmDialogAccept} color="success" autoFocus>
                            <FormattedMessage id="button.validate" defaultMessage="Validate" />
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}
export default (PatientSimpleList);
